import { render, staticRenderFns } from "./LogoutStep.vue?vue&type=template&id=5b0fcbe7"
import script from "./LogoutStep.vue?vue&type=script&lang=js"
export * from "./LogoutStep.vue?vue&type=script&lang=js"
import style0 from "./LogoutStep.vue?vue&type=style&index=0&id=5b0fcbe7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Button: require('/skade-pwa/components/ui/atom/buttons/Button.vue').default})
